<template>
    <div>
        <h1 class="subtitle">Despachos</h1>
        <b-tabs v-model="activeTab" :animated="false" @input="change($event)" type="is-boxed" size="is-small" position="is-centered">
            <!-- < Ordenes venta >-------------------------------------------------------------------------------- -->
            <b-tab-item label="Pedidos venta">
                <div class="nj-cols">
                    <div class="nj-card">
                        <div class="nj-cols form c3">
                            <div>
                                <div class="nj-label">Despachos</div>
                                <select class="nj-select" v-model="orden_venta_filter.est_id" @change="buscarOrdenes()">
                                    <option value="">Todos los estados</option>
                                    <option v-for="item in estados_orden_venta" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Cliente</div>
                                <input type="text" class="nj-text" v-model="orden_venta_filter.cli_search" @keyup.enter="buscarOrdenes()" placeholder="dni / ruc  nombre /  razon social">
                            </div>
                            <InputForm text="Distrito">
                                <select class="nj-select" v-model="orden_venta_filter.ubi_id" @change="buscarOrdenes()">
                                    <option></option>
                                    <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                                </select>
                            </InputForm>
                            <div>
                                <div class="nj-label">Fechas</div>
                                <div class="nj-cols form c2">
                                    <input type="text" class="nj-text" v-model="orden_venta_filter.ovt_fecha_inicio" @keyup.enter="buscarOrdenes()">
                                    <input type="text" class="nj-text" v-model="orden_venta_filter.ovt_fecha_fin" @keyup.enter="buscarOrdenes()">
                                </div>
                            </div>
                            <div>
                                <div class="nj-label">Horas</div>
                                <div class="nj-cols form c2">
                                    <select class="nj-select" v-model="orden_venta_filter.ovt_hora_inicio" @change="buscarOrdenes()">
                                        <option value=""></option>
                                        <option v-for="item in tiempos" :key="item.key" :value="item.value">{{ item.value }}</option>
                                    </select>
                                    <select class="nj-select" v-model="orden_venta_filter.ovt_hora_fin" @change="buscarOrdenes()">
                                        <option value=""></option>
                                        <option v-for="item in tiempos" :key="item.key" :value="item.value">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <Buttons line>
                            <button class="nj-button" @click="buscarOrdenes()">Buscar</button>
                        </Buttons>
                    </div>
                    <div class="nj-card">
                        <b-table :data="ordenes" :paginated="isPaginated" :per-page="perPage" :current-page.sync="ordenCurrentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                            aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                            <template slot-scope="props">
                                <b-table-column label="N°" header-class="is-info">{{ props.row.ovt_id }}</b-table-column>
                                <b-table-column label="DNI / RUC" header-class="is-info">{{ props.row.cli_documento_identidad }}</b-table-column>
                                <b-table-column label="Cliente" header-class="is-info">{{ props.row.cli_nombre }}</b-table-column>
                                <b-table-column label="Fecha venta" header-class="is-info">{{ props.row.ovt_fecha_venta }}</b-table-column>
                                <b-table-column label="Fecha entrega" header-class="is-info">{{ props.row.ovt_fecha_entrega }}</b-table-column>
                                <b-table-column label="Estado" header-class="is-info">
                                    <button class="nj-button" :class="tagEstado(props.row.est_id)">{{ props.row.est_nombre }}</button>
                                </b-table-column>
                                <b-table-column label="Opciones" header-class="is-info">
                                    <button class="nj-button c-green icon" @click="popup({ componente: 'programarEnvio', status: true, orden_venta: props.row })" title="Programar envios"><i class="mdi-calendar"></i></button>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </b-tab-item>
            <!-- < Despachos >-------------------------------------------------------------------------------- -->
            <b-tab-item label="Despachos">
                <div class="nj-cols">
                    <div class="nj-card">
                        <div class="nj-cols form c3">
                            <div>
                                <div class="nj-label">Estado</div>
                                <select class="nj-select" v-model="envio_filter.est_id" @change="buscarEnvios()">
                                    <option>Todos los estados</option>
                                    <option v-for="item in estados_envio" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Cliente</div>
                                <input type="text" class="nj-text" v-model="envio_filter.cli_search" @keyup.enter="buscarEnvios()" placeholder="dni / ruc  nombre /  razon social">
                            </div>
                            <InputForm text="Distrito">
                                <select class="nj-select" v-model="envio_filter.ubi_id" @change="buscarOrdenes()">
                                    <option></option>
                                    <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                                </select>
                            </InputForm>
                            <div>
                                <div class="nj-label">Fechas</div>
                                <div class="nj-cols form c2">
                                    <input type="text" class="nj-text" v-model="envio_filter.env_fecha_inicio" @keyup.enter="buscarEnvios()">
                                    <input type="text" class="nj-text" v-model="envio_filter.env_fecha_fin" @keyup.enter="buscarEnvios()">
                                </div>
                            </div>
                            <div>
                                <div class="nj-label">Horas</div>
                                <div class="nj-cols form c2">
                                    <select class="nj-select" v-model="envio_filter.ovt_hora_inicio" @change="buscarEnvios()">
                                        <option value=""></option>
                                        <option v-for="item in tiempos" :key="item.key" :value="item.value">{{ item.value }}</option>
                                    </select>
                                    <select class="nj-select" v-model="envio_filter.ovt_hora_fin" @change="buscarEnvios()">
                                        <option value=""></option>
                                        <option v-for="item in tiempos" :key="item.key" :value="item.value">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <Buttons line>
                            <button class="nj-button" @click="buscarEnvios()">Buscar</button>
                        </Buttons>
                    </div>
                    <div class="nj-card">
                        <b-table :data="envios" :paginated="isPaginated" :per-page="perPage" :current-page.sync="envioCurrentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                            aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                            <template slot-scope="props">
                                <b-table-column label="N°" header-class="is-info">{{ props.row.env_codigo }}</b-table-column>
                                <b-table-column label="Fecha" header-class="is-info">{{ props.row.fecha_hora.day }}-{{ props.row.fecha_hora.month }}-{{ props.row.fecha_hora.year }}</b-table-column>
                                <b-table-column label="Hora" header-class="is-info">{{ props.row.fecha_hora.hour }}:{{ props.row.fecha_hora.min }}</b-table-column>
                                <b-table-column label="Producto" header-class="is-info">{{ props.row.pvt_nombre }}</b-table-column>
                                <b-table-column label="Cantidad" header-class="is-info">{{ props.row.env_cantidad }}</b-table-column>
                                <b-table-column label="Dirección" header-class="is-info">{{ props.row.ubi_id }}</b-table-column>
                                <b-table-column label="Distrito" header-class="is-info">{{ props.row.ubi_id }}</b-table-column>
                                <b-table-column label="Cambiar estado" header-class="is-info">
                                    <button class="nj-button" :class="tagEstado(props.row.est_id)" @click="cambiarSecuenciaEstado(props.row.env_id)"><i class="mdi-redo"></i> {{ props.row.est_nombre }}</button>
                                </b-table-column>
                                <b-table-column label="Opciones" header-class="is-info">
                                    <div class="nj-flx">
                                        <button class="nj-button icon c-blue" @click="popup({ componente: 'verEnvio', status: true, envio: props.row })" title="Ver"><i class="mdi-information"></i></button>
                                        <button class="nj-button c-green icon" @click="popup({ componente: 'reprogramarEnvio', status: true, envio: props.row })" title="Reprogramar envios"><i class="mdi-calendar"></i></button>
                                        <button class="nj-button icon c-red" v-if="showCancelarEnvio(props.row)" @click="cancelarEnvio(props.row.env_id)" title="Cancelar"><i class="mdi-close-circle"></i></button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </b-tab-item>
            <!-- < Mixers >-------------------------------------------------------------------------------- -->
            <b-tab-item label="Despachos x Mixers">
                <div class="nj-card">
                    <div class="nj-cols form c3">
                        <div>
                            <div class="nj-label">Estado</div>
                            <select class="nj-select" v-model="envio_mixer_filter.est_id" @change="buscarEnvios()">
                                <option value="">Todos los estados</option>
                                <option v-for="item in estados_envio" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Cliente</div>
                            <input type="text" class="nj-text" v-model="envio_mixer_filter.cli_search" @keyup.enter="buscarEnvios()" placeholder="dni / ruc  nombre /  razon social">
                        </div>
                        <InputForm text="Distrito">
                            <select class="nj-select" v-model="envio_mixer_filter.ubi_id" @change="buscarOrdenes()">
                                <option></option>
                                <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                            </select>
                        </InputForm>
                        <div>
                            <div class="nj-label">Fechas</div>
                            <div class="nj-cols form c2">
                                <input type="text" class="nj-text" v-model="envio_mixer_filter.env_fecha_inicio" @keyup.enter="buscarEnvios()">
                                <input type="text" class="nj-text" v-model="envio_mixer_filter.env_fecha_fin" @keyup.enter="buscarEnvios()">
                            </div>
                        </div>
                        <div>
                            <div class="nj-label">Horas</div>
                            <div class="nj-cols form c2">
                                <select class="nj-select" v-model="envio_mixer_filter.ovt_hora_inicio" @change="buscarEnvios()">
                                    <option value=""></option>
                                    <option v-for="item in tiempos" :key="item.key" :value="item.value">{{ item.value }}</option>
                                </select>
                                <select class="nj-select" v-model="envio_mixer_filter.ovt_hora_fin" @change="buscarEnvios()">
                                    <option value=""></option>
                                    <option v-for="item in tiempos" :key="item.key" :value="item.value">{{ item.value }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <Buttons line>
                        <button class="nj-button" @click="buscarEnvios()">Buscar</button>
                    </Buttons>
                </div>
                <br>
                <template v-if="mixers.length != 0">
                    <Buttons line>
                        <button class="nj-button" @click="buscarOrdenes()">Buscar</button>
                    </Buttons>
                    <br>
                    <div class="nj-scroll" style="height: calc(100vh - 200px);">
                        <div style="display: grid; grid-template-columns: 80px repeat(6, 200px)">
                            <div class="time">
                                <div class="time-title">Horas</div>
                                <div class="time-block" v-for="item in horas" :key="item">{{ item }}</div>
                            </div>
                            <MixerItem v-for="mixer in mixers" :key="mixer.mix_id" :mixer="mixer" :estados="estados_envio" />
                        </div>
                    </div>
                </template>
            </b-tab-item>
        </b-tabs>
        <ProgramarEnvios v-if="activarProgramarEnvios" :ovt_id="ovt_id" @close="popup($event)" />
        <ReprogramarEnvios v-if="activarReprogramarEnvios" :ovt_id="ovt_id" @close="popup($event)" />
        <VerEnvio v-if="activarVerEnvio" :env_id="env_id" @close="popup($event)" />
    </div>
</template>

<script>
import { AppService, EnvioService, OrdenVentaService, ResponseStatus } from "../../rest"
import Arrays from "../../util/arrays"
import Confirm from "../../util/confirm"
import DateTime from "../../util/dateTime"
import { EnvioEvent, EnvioEventTypes } from "../../util/events"
import Toast from "../../util/toast"
import { Buttons, InputForm, Button } from "../components"
import MixerItem from "./MixerItem.vue"
import ProgramarEnvios from "./ProgramarEnvios.vue"
import ReprogramarEnvios from "./ReprogramarEnvios.vue"
import VerEnvio from "./VerEnvio.vue"

export default {
    name: "Envios",
    components: {
        ProgramarEnvios,
        ReprogramarEnvios,
        VerEnvio,
        MixerItem,
        Buttons,
        Button,
        InputForm,
    },
    data() {
        return {
            activeTab: 0,
            horas: DateTime.horas,
            animated: false,
            distritos: [],
            orden_venta_filter: {
                cli_nombre: null,
                ovt_fecha_inicio: null,
                ovt_fecha_fin: null,
                ovt_hora_inicio: null,
                ovt_hora_fin: null,
                est_id: null,
            },
            envio_filter: {
                est_id: null
            },
            envio_mixer_filter: {
                est_id: null
            },
            ordenes: [],
            envios: [],
            ovt_id: null,
            env_id: null,
            estados_orden_venta: [],
            estados_envio: [],
            activarProgramarEnvios: false,
            activarReprogramarEnvios: false,
            activarVerEnvio: false,
            tiempos: DateTime.get24Time(),
            mixers: [],
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            ordenCurrentPage: 1,
            envioCurrentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        change(tab) {
            switch (tab) {
                case 0:
                    this.buscarOrdenes()
                    break
                case 1:
                    this.buscarEnvios()
                    break
                case 2:
                    this.buscarEnviosxMixers()
                    break
            }
        },
        verificarEstadoOrden(orden) {
            const creado = Arrays.find(this.estados, "est_codigo", "creado")
            if (!creado) return
            return orden.est_id != creado.id
        },
        buscarOrdenes() {
            this.ordenes = []
            OrdenVentaService.buscar({
                orden_venta: this.orden_venta_filter
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.ordenes = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        buscarEnvios() {
            this.envios = []
            const request = {
                envio: this.envio_filter
            }
            EnvioService
                .buscar(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.envios = response.data
                        this.envios.forEach(item => {
                            item.fecha_hora = DateTime.convertStringToObject(item.env_fecha_hora_envio)
                        })
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        buscarEnviosxMixers() {
            this.mixers = []
            // hay que agregar filtros para la búsqueda de mixers-envios
            EnvioService.buscarEnviosxMixers({
                envio: this.envio_mixer_filter
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.mixers = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        popup({
            componente,
            status,
            renderizar = false,
            envio = null,
            orden_venta = null
        }) {
            switch (componente) {
                case "programarEnvio":
                    if (status) {
                        if (orden_venta && (orden_venta.est_id == 10 || orden_venta.est_id == 11)) {
                            this.ovt_id = orden_venta.ovt_id
                            this.activarProgramarEnvios = status
                        } else {
                            Toast.warn("El pedido venta debe estar aprobado para programarle los envios")
                        }
                    }
                    else if (!status) {
                        this.ovt_id = null
                        this.activarProgramarEnvios = status
                        if (renderizar) {
                            this.buscarEnvios()
                        }
                    }
                    break
                case "reprogramarEnvio":
                    if (status) {
                        if (envio.est_id == 35) {
                            this.env_id = envio.env_id
                            this.ovt_id = envio.ovt_id
                            this.activarReprogramarEnvios = status
                        }
                        else {
                            Toast.warn("El envio debe estar programado para realizar una reprogramacion ")
                        }
                    }
                    else if (!status) {
                        this.ovt_id = null
                        this.activarReprogramarEnvios = status
                        if (renderizar) {
                            this.buscarEnvios()
                        }
                    }
                    break
                case "verEnvio":
                    this.activarVerEnvio = status
                    this.env_id = status ? envio.env_id : null
                    break
            }
        },
        cambiarSecuenciaEstado(env_id) {
            Confirm.show({
                message: "¿Esta seguro de cambiar el estado del envio?",
                action: () => {
                    const request = {
                        envio: {
                            env_id
                        }
                    }
                    EnvioService
                        .cambiarSecuenciaEstado(request)
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscarEnvios()
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        })
                }
            })
        },
        cancelarEnvio(env_id) {
            Confirm.show({
                message: "¿Esta seguro de cancelar el envio?",
                action: () => {
                    EnvioService.cancelarEnvio({
                        envio: {
                            env_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscarEnvios()
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
            })
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        },
        showCancelarEnvio(envio) {
            // se trata de un envio existente
            let estado = this.estados.find(item => item.est_id == envio.est_id)
            if (estado && estado.est_codigo == "programado") {
                return true
            }
            else {
                return false
            }
        },
    },
    mounted() {
        AppService.getData(["estados", "distritos"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    // obteniendo datos para los dropdowns
                    this.estados = response.data.estados
                    this.distritos = response.data.distritos
                    this.estados_envio = Arrays.filter(this.estados, "est_codigo", ["programado", "en_carguio", "en_ruta", "descargando", "en_retorno", "completado", "cancelado"])
                    this.estados_orden_venta = Arrays.filter(this.estados, "est_codigo", ["pagado", "en_proceso", "completado"])
                    // colocando algunos valores por defecto
                    this.orden_venta_filter.ovt_fecha_inicio = DateTime.todayString({days: -7})
                    this.orden_venta_filter.ovt_fecha_fin = DateTime.todayString({days: 2})
                    this.envio_filter.env_fecha_inicio = DateTime.todayString({days: -7})
                    this.envio_filter.env_fecha_fin = DateTime.todayString({days: 2})
                    // iniciando la búsqueda
                    this.buscarOrdenes()
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        // Escuchando un evento global desde el componente EnvioItem.vue
        EnvioEvent.$on(EnvioEventTypes.verEnvio, (envio) => {
            this.verEnvio(true, envio.env_id)
        })
    }
}
</script>

<style scoped>
.time {
    display: grid;
    grid-template-columns: 1fr;
}

.time-title {
    background-color: var(--nj-color-green);
    color: #fff;
    padding: 8px 10px;
    border-right: 1px solid #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
}

.time-block {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    text-align: center;
    border: 1px solid #ccc;
    border-width: 0 1px 1px 1px;
}
</style>